module.exports = "/images/lb.svg?ab5053cc698e62f0926e7224e252748c";